"use strict";

exports.__esModule = true;
exports.DescriptionWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DescriptionElement = require("./DescriptionElement");
var _DescriptionFields = require("./DescriptionFields");
var _DescriptionHeader = require("./DescriptionHeader");
var _DescriptionThumbnail = require("./DescriptionThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DescriptionWidget = exports.DescriptionWidget = {
  name: "Description",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DescriptionWidget.label",
    defaultMessage: "Description"
  }),
  icon: "label",
  group: _widgetGroups.OTHER_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "Description",
      props: Object.assign({
        width: 256,
        height: 256,
        flex: 1,
        textAlignment: "left",
        content: "Click to edit this text."
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "content"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 256,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _DescriptionHeader.DescriptionHeader,
    Element: _DescriptionElement.DescriptionElement,
    Fields: _DescriptionFields.DescriptionFields,
    Thumbnail: _DescriptionThumbnail.DescriptionThumbnail
  }
};